import { useCallback } from 'react';
import { useFirestore } from 'reactfire';
 
import {
  where,
  getCountFromServer,
  query,
  collection,
  CollectionReference,
} from 'firebase/firestore';
import { User } from '../firebase/entities';

type WithId<T> = T & { id: string };
 
const usersCollection = 'users';
 
function useFetchUserCount() {
  const firestore = useFirestore();
 
  return useCallback(
    () => {
      const collectionRef = collection(
        firestore,
        usersCollection
      ) as CollectionReference<WithId<User>>;
 
      return getCountFromServer(
        query(collectionRef)
      );
    },
    [firestore]
  );
}
 
export default useFetchUserCount;